import { render, staticRenderFns } from "./T-F-Under-Grad-2022.vue?vue&type=template&id=091c63dd&scoped=true"
import script from "./T-F-Under-Grad-2022.vue?vue&type=script&lang=js"
export * from "./T-F-Under-Grad-2022.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091c63dd",
  null
  
)

export default component.exports